import { apiFetch, type AjaxResult } from './http';

export type AppSettingsProfile = {
  userId: number;
  userName: string;
  email: string;
  phone: string | null;
  registerDate: string;
  notifyOrder: string;
  notifyPromo: string;
  notifyLogin: string;
};

export async function fetchSettingsProfile(): Promise<AjaxResult<AppSettingsProfile>> {
  return apiFetch('/api/app/settings/profile', { method: 'GET', auth: true });
}

export async function updateSettingsProfile(data: { userName?: string; email?: string; phone?: string }): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/settings/profile', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });
}

export async function updateSettingsPassword(data: { oldPassword: string; newPassword: string }): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/settings/password', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });
}

export async function updateSettingsNotify(data: { notifyOrder: boolean; notifyPromo: boolean; notifyLogin: boolean }): Promise<AjaxResult<unknown>> {
  return apiFetch('/api/app/settings/notify', {
    method: 'PUT',
    auth: true,
    body: JSON.stringify(data),
  });
}
